"use strict";

angular.module("mean.admin-panel").controller("TradeAdminCompanyController", [
    "$scope",
    "Users",
    "Global",
    "MeanUser",
    "$filter",
    "toaster",
    "$q",
    "AdminPanel",
    "Contractors",
    "Trades",
    "userService",
    "Subtasks",
    "tradeCodeService",
    "$location",
    "$http",
    function (
        $scope,
        Users,
        Global,
        MeanUser,
        $filter,
        toaster,
        $q,
        AdminPanel,
        Contractors,
        Trades,
        userService,
        Subtasks,
        tradeCodeService,
        $location,
        $http
    ) {
        $scope.global = Global;
        $scope.package = {
            name: "admin-panel",
        };

        console.log("trade admin company controller");

        $scope.user = MeanUser.user;
        $scope.main_id = 0;

        $scope.sortableOptions = {
            connectWith: ".connectPanels",
            handler: ".ibox-title",
        };

        for (var i = 0; i < $scope.user.roles.length; i++) {
            if ($scope.user.roles[i] === "tm_admin") {
                $scope.trade_admin = true;
            }
            if ($scope.user.roles[i] === "tm_office") {
                $scope.trade_admin = true;
            }
        }

        $scope.dateOptions = {
            //dateDisabled: disabled,
            formatYear: "yy",
            //minDate: new Date(),
            maxDate: new Date(2030, 1, 20),
            showWeeks: false,
            startingDay: 0,
        };

        $scope.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened = true;
        };

        $scope.openEnd = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.endOpened = true;
        };

        $scope.editOpen = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $timeout(function () {
                $scope.editOpened = true;
            }, 50);
        };

        if (!$scope.trade_admin) {
            toaster.pop(
                "error",
                "Company Admin Panel",
                "You do not have the proper permissions for this page."
            );
            $location.path("home");
            return;
        }

        userService.getMainAccountId(MeanUser.user.username).then(
            function (result) {
                $scope.main_id = result;
                Trades.query({ main_account_id: result }, function (trades) {
                    if (trades.length === 1) {
                        $scope.selectedTrade = trades[0];
                        $scope.selectedTrade.payroll_end_date = new Date(
                            $scope.selectedTrade.payroll_end_date
                        );
                        $scope.selectedTrade.typical_clock_in = new Date(
                            $scope.selectedTrade.typical_clock_in
                        );
                        $scope.selectedTrade.typical_lunch_start = new Date(
                            $scope.selectedTrade.typical_lunch_start
                        );
                        $scope.selectedTrade.typical_lunch_end = new Date(
                            $scope.selectedTrade.typical_lunch_end
                        );
                        $scope.selectedTrade.typical_clock_out = new Date(
                            $scope.selectedTrade.typical_clock_out
                        );
                        if (
                            $scope.selectedTrade.logo_one == null ||
                            $scope.selectedTrade.logo_one == ""
                        ) {
                            $scope.selectedTrade.logo_one =
                                "inspinia/assets/img/logo_one_no_image.jpg";
                        }

                        if (
                            $scope.selectedTrade.reports_logo == null ||
                            $scope.selectedTrade.reports_logo == ""
                        ) {
                            $scope.selectedTrade.reports_logo =
                                "inspinia/assets/img/logo_one_no_image.jpg";
                        }
                    } else if (trades.length === 0) {
                        toaster.pop(
                            "warning",
                            "Admin Panel",
                            "No Trade information in the database. Adding now."
                        );
                        $scope.addTrade();
                    } else {
                        toaster.pop(
                            "error",
                            "Admin Panel",
                            "Too many Trade database entries. Contact Admin."
                        );
                        return;
                    }
                });
            },
            function (error) {
                toaster.pop(
                    "error",
                    "Admin Panel",
                    "Problem getting the main account user information"
                );
            }
        );

        $scope.processProjectHours = function () {
            //code is a copy in forman controller file
            //call processProjectHours on the server and pass user object in the request
            var start = moment().startOf("day");
            var end = moment().endOf("day");
            console.log(
                "getting start day",
                start.toString(),
                " and end day",
                end.toString()
            );
            // var start = moment()
            //     .set("year", 2017)
            //     .set("month", 0)
            //     .set("date", 1);
            // var end = moment().set("year", 2018).set("month", 6).set("date", 1);
            $http
                .get("/api/projectHoursProcess", {
                    params: {
                        username: $scope.user.username,
                        roles: $scope.user.roles,
                        mainusername: userService.getMainUsername(
                            $scope.user.username
                        ),
                        start: start.toDate(),
                        end: end.toDate(),
                        trade: $scope.user.trade[0],
                        company_code: $scope.user.contractor_code,
                    },
                })
                .then(
                    function (response) {
                        console.log("processProjectHours complete");
                        $scope.project_reports = response.data;
                    },
                    function (error) {
                        console.log("processProjectHours error");
                    }
                );
        };

        $scope.addTrade = function () {
            if ($scope.user._id !== $scope.main_id) {
                toaster.pop(
                    "error",
                    "Admin Panel",
                    "Could not create database entry.  Log in under main account"
                );
                return;
            }

            Subtasks.query(
                {
                    subtask_trade: tradeCodeService.getCode(
                        $scope.user.trade[0]
                    ),
                },
                function (subtasks) {
                    for (var i = 0; i < subtasks.length; i++) {
                        subtasks[i].code = subtasks[i].subtask_code;
                        subtasks[i].name = subtasks[i].subtask_name;
                        subtasks[i].subtask_id = subtasks[i]._id;
                        subtasks[i].task = subtasks[i].subtask;
                        subtasks[i].trade = subtasks[i].subtask_trade;
                        subtasks[i].unit = subtasks[i].unit.unit;
                    }

                    var trade = new Trades({
                        trade: $scope.user.trade[0],
                        main_account_id: $scope.user._id,
                        subtasks: subtasks,
                        company_code: userService.getCompanyCode(
                            $scope.user.username
                        ),
                    });

                    trade.$save(
                        function (response) {
                            toaster.pop(
                                "success",
                                "Admin Panel",
                                "Trade database has been updated"
                            );
                            $scope.selectedTrade = response;
                            $scope.selectedTrade.payroll_end_date = new Date(
                                $scope.selectedTrade.payroll_end_date
                            );
                            $scope.selectedTrade.typical_clock_in = new Date(
                                $scope.selectedTrade.typical_clock_in
                            );
                            $scope.selectedTrade.typical_lunch_start = new Date(
                                $scope.selectedTrade.typical_lunch_start
                            );
                            $scope.selectedTrade.typical_lunch_end = new Date(
                                $scope.selectedTrade.typical_lunch_end
                            );
                            $scope.selectedTrade.typical_clock_out = new Date(
                                $scope.selectedTrade.typical_clock_out
                            );

                            if (
                                $scope.selectedTrade.logo_one == null ||
                                $scope.selectedTrade.logo_one == ""
                            ) {
                                $scope.selectedTrade.logo_one =
                                    "inspinia/assets/img/logo_one_no_image.jpg";
                            }

                            if (
                                $scope.selectedTrade.reports_logo == null ||
                                $scope.selectedTrade.reports_logo == ""
                            ) {
                                $scope.selectedTrade.reports_logo =
                                    "inspinia/assets/img/logo_one_no_image.jpg";
                            }
                        },
                        function (error) {
                            toaster.pop("error", "Admin Panel", error.data);
                        }
                    );
                }
            );
        };

        $scope.update = function () {
            $scope.selectedTrade.$update(
                function (response) {
                    $scope.selectedTrade = response;
                    $scope.selectedTrade.payroll_end_date = new Date(
                        $scope.selectedTrade.payroll_end_date
                    );
                    $scope.selectedTrade.typical_clock_in = new Date(
                        $scope.selectedTrade.typical_clock_in
                    );
                    $scope.selectedTrade.typical_lunch_start = new Date(
                        $scope.selectedTrade.typical_lunch_start
                    );
                    $scope.selectedTrade.typical_lunch_end = new Date(
                        $scope.selectedTrade.typical_lunch_end
                    );
                    $scope.selectedTrade.typical_clock_out = new Date(
                        $scope.selectedTrade.typical_clock_out
                    );

                    if (
                        $scope.selectedTrade.logo_one == null ||
                        $scope.selectedTrade.logo_one == ""
                    ) {
                        $scope.selectedTrade.logo_one =
                            "inspinia/assets/img/logo_one_no_image.jpg";
                    }

                    if (
                        $scope.selectedTrade.reports_logo == null ||
                        $scope.selectedTrade.reports_logo == ""
                    ) {
                        $scope.selectedTrade.reports_logo =
                            "inspinia/assets/img/logo_one_no_image.jpg";
                    }

                    toaster.pop(
                        "success",
                        "Company Admin Panel",
                        "Trade database has been updated"
                    );
                },
                function (error) {
                    toaster.pop("error", "Company Admin Panel", error);
                }
            );
        };

        $scope.setFile = function (element) {
            $scope.currentFile = element.files[0];
            var reader = new FileReader();
            console.log("setFile");
            reader.onload = function (event) {
                if (event.total < 50000) {
                    $scope.selectedTrade.logo_one = event.target.result;
                    $scope.$apply();

                    $http
                        .post("/api/trades/image", {
                            tradeId: $scope.selectedTrade._id,
                            file: $scope.selectedTrade.logo_one,
                        })
                        .success(function (data, status, headers, config) {
                            console.log("photo uploaded successfully.");
                            toaster.pop("susscess", "Logo Updated");
                        })
                        .error(function (data, status, headers, config) {
                            console.log("There was an error with the upload");
                            toaster.pop("susscess", "Logo Update Error");
                        });
                } else {
                    toaster.pop(
                        "error",
                        "Logo Upload Error",
                        "Has to be smaller than 50 kilobytes"
                    );
                }
            };
            // when the file is read it triggers the onload event above.
            reader.readAsDataURL(element.files[0]);
        };

        $scope.setReportsFile = function (element) {
            $scope.currentFile = element.files[0];
            var reader = new FileReader();
            console.log("setFile");
            reader.onload = function (event) {
                if (event.total < 50000) {
                    $scope.selectedTrade.reports_logo = event.target.result;
                    $scope.$apply();

                    $http
                        .post("/api/trades/image", {
                            tradeId: $scope.selectedTrade._id,
                            file: $scope.selectedTrade.reports_logo,
                        })
                        .success(function (data, status, headers, config) {
                            console.log("photo uploaded successfully.");
                            toaster.pop("susscess", "Logo Updated");
                        })
                        .error(function (data, status, headers, config) {
                            console.log("There was an error with the upload");
                            toaster.pop("susscess", "Logo Update Error");
                        });
                } else {
                    toaster.pop(
                        "error",
                        "Logo Upload Error",
                        "Has to be smaller than 50 kilobytes"
                    );
                }
            };
            // when the file is read it triggers the onload event above.
            reader.readAsDataURL(element.files[0]);
        };

        $scope.removeLogoOne = function () {
            $scope.selectedTrade.logo_one = "";
            $scope.update();
        };

        $scope.removeReportsLogo = function () {
            $scope.selectedTrade.reports_logo = "";
            $scope.update();
        };

        var handleFileSelect = function (evt) {
            console.log("in the function");
            var file = evt.currentTarget.files[0];
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    $scope.myImage = evt.target.result;
                });
            };
            reader.readAsDataURL(file);
        };
        angular
            .element(document.querySelector("#fileInput"))
            .on("change", function (h1, h2, h3, h4) {
                console.log("this is getting called");
            });

        $scope.states = [
            "Alabama",
            "Alaska",
            "Arizona",
            "Arkansas",
            "California",
            "Colorado",
            "Connecticut",
            "Delaware",
            "Florida",
            "Georgia",
            "Hawaii",
            "Idaho",
            "Illinois",
            "Indiana",
            "Iowa",
            "Kansas",
            "Kentucky",
            "Louisiana",
            "Maine",
            "Maryland",
            "Massachusetts",
            "Michigan",
            "Minnesota",
            "Mississippi",
            "Missouri",
            "Montana",
            "Nebraska",
            "Nevada",
            "New Hampshire",
            "New Jersey",
            "New Mexico",
            "New York",
            "North Carolina",
            "North Dakota",
            "Ohio",
            "Oklahoma",
            "Oregon",
            "Pennsylvania",
            "Rhode Island",
            "South Carolina",
            "South Dakota",
            "Tennessee",
            "Texas",
            "Utah",
            "Vermont",
            "Virginia",
            "Washington",
            "West Virginia",
            "Wisconsin",
            "Wyoming",
        ];
    },
]);



// WEBPACK FOOTER //
// ./packages/custom/admin-panel/public/controllers/tradeAdminCompany.js